// import testComp from './test/test-comp'

// ./public文件夹内组件将自动注册   组件内需要写name,格式为驼峰 myComponent
let autoInitComponents = []
let Components = require.context('./public', false, /\.vue/)
Components.keys().forEach((key) => {
  if (Components(key).default) autoInitComponents.push(Components(key).default)
})

const components = {
  install: function(Vue) {
    autoInitComponents.forEach((comp) => {
      Vue.component(comp.name, comp)
    })

    // Vue.component('testComp', testComp) //手动引入 示例
  },
}
export default components
